import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';

export default class DropdownsThemesComponent extends DropdownActivator {
  @service store;
  @service('themes') themesService;
  @service intl;
  @tracked textFilter = null;
  @tracked tippyInstance = null;

  get themes() {
    return [...this.store.peekAll('theme')];
  }

  get deleteObject() {
    return { id: 'clear', title: this.intl.t('dictionary.clear-selection') };
  }

  get showDelete() {
    return this.args?.value?.get('id') && this.deleteObject;
  }

  get searchable() {
    const themes = this.themes;
    return themes.length > 6;
  }

  get themesList() {
    const themes = this.themes;
    return !this.textFilter
      ? themes
      : themes.filter(
          (item) =>
            item.title.toLowerCase().indexOf(this.textFilter.toLowerCase()) >=
            0,
        );
  }

  @action
  handleSearch(text) {
    this.textFilter = text;
  }

  @action
  loadThemes() {
    return this.themesService.getThemes();
  }

  @action
  onSelect(e) {
    this.args?.onSelect(e);
  }

  @action
  setTippyInstance(instance) {
    this.tippyInstance = instance;
  }

  focusSearch() {
    const search = document.querySelector('.inner-tippy-dropdown #searchable');
    if (search) search.focus();
  }

  @action
  handleClearSelection() {
    this.tippyInstance?.hide?.();
    this.onSelect(this.deleteObject);
  }

  willDestroy() {
    this.tippyInstance?.destroy?.();
    this.tippyInstance = null;
    this.textFilter = null;
    super.willDestroy(...arguments);
  }
}
